module.exports = __webpack_public_path__ + "media/images/modals/Okra_And_Beats_Jamaica_sm-8cb786c0f4f47a987a1b8d7b66d51b94.jpg";